import { Avatar, DateFormatter } from '@components'

import { Color, Flex, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DmsDocument } from '../../../../types'
import * as Styled from './styles'

interface DocumentDetailsProps {
  document: DmsDocument
}

export const DocumentDetails = ({ document }: DocumentDetailsProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.DetailsWrapper>
      <Flex flexDirection="column">
        <Text weight="bold">{t('documents.file_view.details_title')}</Text>
        <Space size="s4" />
        <Text variant="bodySM" colorVariant="secondary">
          {document.name}
        </Text>
      </Flex>

      <Space size="s32" />

      <Flex alignItems="center" gap={Spacing.S8}>
        <Text variant="bodySM" colorVariant="secondary">
          {t('documents.file_view.date_added')}
        </Text>
        <Text variant="bodyMD">
          <DateFormatter value={document.uploadedAt} />
        </Text>
      </Flex>

      <Flex alignItems="center" gap={Spacing.S14}>
        <Text variant="bodySM" colorVariant="secondary">
          {t('documents.file_view.added_by')}
        </Text>
        <Flex alignItems="center">
          <Avatar noMargin size="m" name={document.uploadedBy?.name} backgroundColor={Color.Purple100} />
          <Space horizontal size="s8" />
          <Text variant="bodyMD">{document.uploadedBy?.name}</Text>
        </Flex>
      </Flex>
    </Styled.DetailsWrapper>
  )
}
